<div class="kyc-status-rejected form-container">
  <ng-container *ngIf="!!validation?.can_request_validator; else cannotRequest">
    <ng-container *ngIf="validation?.validator_completed === VALIDATOR.BURO">
      <img src="assets/icons/caution.svg" alt="Icono advertencia" />
      <h4>Revisa tu DNI</h4>
      <p>Te recomendamos revisar el número de DNI que ingresaste e intentar nuevamente.</p>
      <div>
        <button class="btn-primary-bg" (click)="onReturnToPersonalInfo()">Entendido</button>
      </div>
    </ng-container>

    <ng-container *ngIf="validation?.validator_completed === VALIDATOR.KEY_NUA">
      <img src="assets/icons/caution.svg" alt="Icono advertencia" />
      <h4>Revisa los datos de tu DNI</h4>
      <p>Verifica la fecha de emisión de tu DNI o los nombres ingresados.</p>
      <div>
        <button class="btn-primary-bg" (click)="onReturnToPersonalInfo()">Entendido</button>
      </div>
    </ng-container>

    <ng-container *ngIf="validation?.validator_completed === VALIDATOR.LLEIDA">
      <img src="assets/icons/caution.svg" alt="Icono advertencia" />
      <h4>Revisa los datos de tu DNI</h4>
      <p>Verifica la fecha de emisión de tu DNI.</p>
      <div>
        <button class="btn-primary-bg" (click)="onReturnToPersonalInfo()">Entendido</button>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #cannotRequest>
  <ng-container *ngIf="!validation?.rejected_by_offer">
    <layout-kyc-verification-error
      [isLoading]="isLoading"
      (killPurchaseEvent)="onKillPurchase()"
    ></layout-kyc-verification-error>
  </ng-container>
  <ng-container *ngIf="validation?.rejected_by_offer">
    <layout-kyc-status-rejected-by-offer
      [isLoading]="isLoading"
      (killPurchaseEvent)="onKillPurchase()"
    ></layout-kyc-status-rejected-by-offer>
  </ng-container>
</ng-template>
